var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #928980;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #331e11;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.62,
    y: 37.52,
    width: 5.51,
    height: 5.51,
    rx: 2.75,
    ry: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.53,
    y: 33.07,
    width: 21.05,
    height: 14.14,
    rx: 7.07,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.58,
    y: 36.76,
    width: 5.58,
    height: 6.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.83,
    y: 36.9,
    width: 5.58,
    height: 6.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.12,
    y: 30.59,
    width: 6.11,
    height: 19.37,
    rx: 3.05,
    ry: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.57,
    y: 35.45,
    width: 6.11,
    height: 9.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.12,
    y: 23.7,
    width: 5.51,
    height: 6.69,
    rx: 2.75,
    ry: 2.75,
    transform: "translate(-5.01 13.02) rotate(-13.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.12,
    y: 49.72,
    width: 5.51,
    height: 6.69,
    rx: 2.75,
    ry: 2.75,
    transform: "translate(23.52 -15.17) rotate(21.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.87,
    y: 37.53,
    width: 5.51,
    height: 5.51,
    rx: 2.75,
    ry: 2.75,
    transform: "translate(-2.61 4.52) rotate(-3.93)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.12,44.14v-7.5l.25-.5m-.25,8l1.5,2.5,3.5,1h4.5l2.5-.5,4-1.2m-16-1.8h-4l-1.5-1m22.5-8.5l-5-1.5-2.5-.5h-4.5l-3.5,1-1.25,2.5m16.75-1.5l3,2,1,1v5l-1,1.5-3,1.5-1,.3m1-11.3l9.5,.5m-32,8v-6m0,6l-2.5-.5-2-1.5v-2l2-1.5,2.5-.5m0,0l1.5-1h4.25m26.25-1v-3.5l.5-.5m-.5,4v10m0,0v3l.5,.67m-.5-3.67l-10.5,.8m18-1.8v1.5l-1.5,3.25-1.25,.88m2.75-5.62h3.5l1.5-1m-5,1v-8m5,7v-5.5m0,5.5h2.5l2-.94,.5-1.56-.5-2-2-1h-2.5m0,0l-1.5-1.5h-3.5m0,0v-1l-1.5-3.5-.62-.5-.94-.75m.31,19.38l-1.25,.88-2-.5-1-1.33m4.25,.96l-1.75,4.38-1,1.5-1.5,.5-2-1v-1.5l.5-1.5,1.5-3.33m0-17.67l1-1,2-.5,.94,.75m-3.94,.75l-1.5-4.5v-1.5l.5-1,2-.5,1,1,.5,1,1.44,4.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoped);
export default __webpack_public_path__ + "static/media/moped.063629d8842b0f7e64932b0ec807aee5.svg";
export { ForwardRef as ReactComponent };